import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Upload from '../views/Upload.vue'
import Contact from '../views/Contact.vue'
import NotFound from '../views/NotFound.vue'

const routes = [{
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/upload',
        name: 'Upload',
        component: Upload,
        meta: { title: 'چاپ عکس' }
    },
    {
        path: '/contact-us',
        name: 'Contact',
        component: Contact,
        meta: { title: 'تماس با ما' }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    },
]


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active", // active class for non-exact links.
    linkExactActiveClass: "exactive", // active class for *exact* links
    scrollBehavior(to, from) {
        if (
            (from.name != undefined & from.name != to.name) |
            (from.params.key != undefined & from.params.key != to.params.key)

        ) {
            var elmnt = document.getElementById("topMenu");

            return {
                top: elmnt.offsetTop + (elmnt.offsetHeight - 32),
                behavior: 'smooth',
            }
        }
    }
})

router.beforeEach((to, from, next) => {
    let documentTitle = `${process.env.VUE_APP_TITLE}`;
    if (to.meta.title) {
        documentTitle = `${to.meta.title} - ` + documentTitle;
    }
    document.title = documentTitle;
    next()
});

export default router